export default __webpack_public_path__ + "fonts/dd9e2a49022a2a6b8a571fbba007cd2e.eot";